import { IStore } from '../../index'
import { createSelector } from 'reselect'

export function getPaymentDictionary(state: IStore) {
  return state.paymentDictionary.dictionaries
}

export function getPaymentDictionaryWithoutDeleted(state: IStore) {
  return state.paymentDictionary.dictionaries.filter(item => !item.isDeleted)
}

export const getTaxDictionary = (state: IStore) =>
  state.paymentDictionary.taxDictionaries.filter(t => !t.deleted)
export const getTaxDictionaryWithDeleted = (state: IStore) =>
  state.paymentDictionary.taxDictionaries
export const getInvoiceSettings = (state: IStore) =>
  state.paymentDictionary.invoiceSettings
export const getTaxServices = (state: IStore) =>
  state.paymentDictionary.services
export const getTaxServicesWithoutDeleted = createSelector(
  [getTaxServices],
  services => services.filter(s => !s.deleted),
)
export const getDefaultTaxServices = (state: IStore) =>
  state.paymentDictionary.defaultServices
export const getPaymentMethod = (state: IStore) =>
  state.paymentDictionary.paymentMethod

export const getPaymentMethodError = (state: IStore) =>
  state.paymentDictionary.error
